// Debug utility for production-safe logging
const isDev = process.env.NODE_ENV === 'development';

// Production-safe logging functions
export const debugLog = isDev ? console.log : () => {};
export const debugWarn = isDev ? console.warn : () => {};
export const debugInfo = isDev ? console.info : () => {};

// Keep errors in production for monitoring
export const debugError = console.error;

// Analytics-specific logging (only in development)
export const analyticsLog = isDev ? console.log : () => {};